import React, {memo, useContext, useEffect, useMemo} from "react";
import {MonitoringLogModalProps} from "../MonitoringLogModal";
import classNames from "classnames/bind";
import styles from "./MonitoringLogList.module.scss";
import {Table} from "reactstrap";
import {CustomerServiceDashboardContext} from "../../context";
import {MonitoringLog} from "../../../../Controllers/CustomerServiceDashboard/CustomerServiceDashboard";
import {useCustomerServiceDashboardStore} from "../../store";

const classes = classNames.bind(styles);

interface MonitoringLogListProps {
}

export const MonitoringLogList = (props: MonitoringLogListProps) => {
    // const {state, dispatch} = useContext(CustomerServiceDashboardContext);
    // const monitoringLogs = useMemo(() => {
    //     if (!state.monitoringLogs) return [];
    //     return state.monitoringLogs;
    // }, [state.monitoringLogs]);
    // const fetchMonitoringLogs = useCustomerServiceDashboardStore(state => state.fetchMonitoringLogs);
    // const  monitoringLogs = useCustomerServiceDashboardStore(state => state.monitoringLogs);
    const {fetchMonitoringLogs, monitoringLogs} = useCustomerServiceDashboardStore();
    // useEffect(() => {
    //     // fetchMonitoringLogs();
    // }, [fetchMonitoringLogs]); 
    
    const TableRows = memo(({monitoringLogs}: { monitoringLogs: MonitoringLog[] }) => {
        return (
            <>
                {monitoringLogs.length && monitoringLogs.map((log: MonitoringLog, index: number) => {
                    return (
                        <tr key={`${log.logGUID}_${index}`}>
                            <td className={classes("item")}>{log.actionTime}</td>
                            <td className={classes("item")}>{log.accountNumber}</td>
                            <td className={classes("item")}>{log.displaySerial}</td>
                            <td className={classes("item")}>{log.description}</td>
                            <td className={classes("item")}>{log.resolution}</td>
                            <td className={classes("item")}>{log.resolved}</td>
                            <td className={classes("item")}>{log.incidentType}</td>
                        </tr>
                    )
                })
                }
            </>
        )
    })

    return (
        <Table className={classes("list")}>
            <thead className={classes("header")}>
            <tr>
                <th className={classes("item")}>Date</th>
                <th className={classes("item")}>Type</th>
                <th className={classes("item")}>Message</th>
                <th className={classes("item")}>Details</th>
            </tr>
            </thead>
            <tbody className={classes("body")}>
            {monitoringLogs.length && monitoringLogs.map((log: MonitoringLog, index: number) => {
                return (
                    <tr key={`${log.logGUID}_${index}`}>
                        <td className={classes("item")}>{log.actionTime}</td>
                        <td className={classes("item")}>{log.accountNumber}</td>
                        <td className={classes("item")}>{log.displaySerial}</td>
                        <td className={classes("item")}>{log.description}</td>
                        <td className={classes("item")}>{log.resolution}</td>
                        <td className={classes("item")}>{log.resolved}</td>
                        <td className={classes("item")}>{log.incidentType}</td>
                    </tr>
                )
            })
            }
            {/*{monitoringLogs &&*/}
            {/*    <TableRows monitoringLogs={monitoringLogs}/>*/}
            {/*}*/}
            </tbody>
        </Table>
    )
}

export default MonitoringLogList;